import { Form, Input } from 'antd';

import { useMemoState } from 'hooks';
import { getFormattedCurrency } from 'utils';

import { TFieldProps } from 'types';

import { handlePriceBlur, handlePriceChange } from './formInputCurrencyHelpers';

const { Item } = Form;

interface IInputCurrencyProps extends Pick<TFieldProps, 'disabled' | 'inputStyles' | 'placeholder' | 'name'> {
  value?: string;
  onChange?: (value: number | string) => void;
}

const InputCurrency = ({ name, value, disabled, inputStyles, placeholder, onChange }: IInputCurrencyProps) => {
  const [price, setPrice] = useMemoState(getFormattedCurrency(value));

  return (
    <Input
      id={name.toString()}
      allowClear
      prefix='$'
      value={price}
      style={inputStyles}
      disabled={disabled}
      placeholder={placeholder}
      onBlur={handlePriceBlur(setPrice)}
      onChange={handlePriceChange(setPrice, onChange)}
    />
  );
};

export const FormInputCurrency = ({
  name,
  label,
  rules,
  tooltip,
  disabled,
  placeholder,
  inputStyles,
  itemClassName,
}: Omit<TFieldProps, 'type'>) => (
  <Item
    name={name}
    rules={rules}
    label={label}
    tooltip={tooltip}
    labelAlign='left'
    className={itemClassName}
  >
    <InputCurrency
      name={name}
      disabled={disabled}
      inputStyles={inputStyles}
      placeholder={placeholder}
    />
  </Item>
);
